@if(isGridVisible){
<div class="content-header">
  <h2>Reporte Solicitudes Alta Plataforma Interconexión Instituciones Públicas</h2>
</div>
<oaj-alert-itx></oaj-alert-itx>
<form [formGroup]="formulario" (ngSubmit)="buscar()">
  <div class="reprint-filters-container">

    <div class="filter-group-box type-filter-group">
      <label for="tipo-acuse">Tipo de Reporte Interconexión:</label>
      <select id="tipo-acuse" class="form-select" formControlName="tipo">
        <option [value]="5">Pendientes de Confirmar Correo</option>
        <option [value]="1">Pendientes</option>
        <option [value]="4">En revisión</option>
        <option [value]="2">Dictaminadas</option>
        <!-- <option [value]="3">Rechazadas</option> -->
        <option [value]="0">Todas</option>
      </select>
    </div>

    <div class="filter-group-box date-filter-group">
      <label for="date">Buscar por fecha</label>
      <div class="date-inputs">
        <input type="date" class="form-control date-input eligeFecha" formControlName="fechaInicio" />
        <input type="date" class="form-control date-input eligeFecha" formControlName="fechaFin" />
        <button class="btn-search">
          Buscar
        </button>
      </div>
    </div>
  </div>

  <br>
  @if(datosExport.length > 0){
  <div class="export-buttons">
    <button type="button" class="btn btn-success me-2" (click)="exportarExcel()">
      <i class="fas fa-file-excel"></i> Exportar a Excel
    </button>
    <button type="button" class="btn btn-danger" (click)="exportarPDF()">
      <i class="fas fa-file-pdf"></i> Exportar a PDF
    </button>
  </div>
  }



</form>
@if(loading){
<div class="loading-overlay">
  <div class="loading-indicator">Cargando registros...</div>
</div>
}



<div class="table-container2 tablaReimpresion">
  <div>
    <table class="tableReporte">
      <thead>
        <tr>
          <th rowspan="2">Número de solicitud</th>
          <th rowspan="2">Entidad</th>
          <th rowspan="2">Dependencia</th>
          <th rowspan="2">Autoridad</th>
          <th rowspan="2">Solicitante</th>
          <th colspan="3" class="text-center">Datos de contacto</th>
          <th rowspan="2">Observaciones Capturadas en la Solicitud</th>
          <th rowspan="2">Documentos</th>
          @if (+tipoReporteSeleccionado !== 5) {
            <th rowspan="2">Fecha recepción de solicitud</th>
          }
          <th rowspan="2">Estatus</th>

          @if (+tipoReporteSeleccionado === 4) {
          <th rowspan="2">Usuario revisor</th>
          <th rowspan="2">Emitir Dictaminación <br>(Rechazada - Aceptada)</th>
          <th rowspan="2">Regresar a Estatus Pendiente</th>
          }

          @if (+tipoReporteSeleccionado === 2) {
          <th rowspan="2">Sentido Dictaminación</th>
          <th rowspan="2">Fecha dictaminación</th>
          <th rowspan="2">Usuario Dictaminador</th>
          <th rowspan="2">Reenvio de Correo de Respuesta</th>
          <th rowspan="2">Documento de Aceptación Autoridad</th>
          }

          @if (+tipoReporteSeleccionado === 0) {
          <th rowspan="2">Sentido Dictaminación</th>
          <th rowspan="2">Fecha dictaminación</th>
          <th rowspan="2">Usuario Revisor / Dictaminador</th>
          <th rowspan="2">Reenvio de Correo de Respuesta</th>
          <th rowspan="2">Documento de Aceptación Autoridad</th>
          }

          @if (+tipoReporteSeleccionado === 5) {
          <th rowspan="2">Reenvio de Correo de Verificación</th>
          }

          @if (+tipoReporteSeleccionado === 1) {
          <th rowspan="2">Pasar a Revisión</th>
          <th rowspan="2">Usuario revisor</th>
          }
        </tr>
        <tr>
          <th>Correo Oficial de la Institución</th>
          <th>Correo Oficial del Solicitante</th>
          <th>Teléfono Institucional del Solicitante</th>
        </tr>
      </thead>

      <tbody>
        @for (item of (datos | async); track $index) {
        <tr>
          <td>{{item.kIdAutoEnrolamiento}}</td>
          <td>{{item.entidadFederativa}}</td>
          <td>{{item.sNombreOficial}}</td>
          <td>{{item.sAutoridad}}</td>
          <td>{{item.sSolicitante}}</td>
          <td>{{item.sCorreoInstitucion}}</td>
          <td>{{item.sCorreoSolicitante}}</td>
          <td>{{item.sTelSolicitante}}</td>
          <td class="observaciones-cell">{{item.sObservaciones}}</td>
          <td>
            @if (item.iDocumentos > 0) {
            <button class="icon-button" ngbTooltip="Visualizar" (click)="abrirModal(item.kIdAutoEnrolamiento)">
              <i class="fas fa-eye iconDescarga"></i>
            </button>
            }
          </td>
          @if (+tipoReporteSeleccionado !== 5){
            @if(item.iStatusSolicitud !== 5){
              <td>{{item.fechaRegistro}}</td>
            } @else {
                <td></td>
            }
          }
          <td>
            @switch (item.iStatusSolicitud) {
            @case (1) { Pendiente }
            @case (2) { Dictaminada }
            @case (3) { Dictaminada }
            @case (4) { En revisión }
            @case (5) { Pendiente de Confirmar Correo }
            @default { Desconocido }
            }
          </td>


          @if (+tipoReporteSeleccionado === 4) {
          <td>
            @if(item.usuarioRevisor.toString() === '1'){
            <button class="icon-button" ngbTooltip="Ver bitácora de cambios de estatus"
              (click)="abrirModalBitacoraEstatus(item.kIdAutoEnrolamiento)">
              <i class="fas fa-file-alt"></i>
            </button>
            }
          </td>
          <td>
            <button class="icon-button" ngbTooltip="Emitir dictaminación" (click)="abrirDictaminacion(item.kIdAutoEnrolamiento)">
              <i class="fas fa-cogs"></i>
            </button>
          </td>
          <td>
            <button class="icon-button" ngbTooltip="Regresar a Estatus Pendiente"
              (click)="abrirModalValidaPendiente(item.kIdAutoEnrolamiento)">
              <i class="fas fa-history"></i>
            </button>
          </td>
          }

          @if (+tipoReporteSeleccionado === 2) {
          <td style="white-space: nowrap;">
            <button class="icon-button" ngbTooltip="Ver motivo de la dictaminación"
              (click)="abrirModalMotivoDictaminacion(item.iStatusSolicitud,
                item.sTextoAdicional, item.sMotivoRechazo 
              )">
              <i class="fas fa-sticky-note"></i>
            </button>
            {{item.sentidoDictaminacion}}
          </td>
          <td>@if (+item.iStatusSolicitud === 2){
             {{item.fechaDictamen}}
            } @else { 
              {{item.fechaRechazo}}
             }
          </td>
          <td>
            @if(item.usuarioRevisor.toString() === '1'){
            <button class="icon-button" ngbTooltip="Ver bitácora de cambios de estatus"
              (click)="abrirModalBitacoraEstatus(item.kIdAutoEnrolamiento)">
              <i class="fas fa-file-alt"></i>
            </button>
            }
          </td>
          <td>    
            <button class="icon-button" ngbTooltip="Reenviar correo" (click)="reenvioCorreo(item.kIdAutoEnrolamiento)">
              <i class="fas fa-envelope"></i>
            </button>
          </td>
          <td>
            @if (item.iDocumentoAceptacion > 0) {
            <button class="icon-button" ngbTooltip="Visualizar"
              (click)="abrirModalDocumentoAceptacion(item.kIdAutoEnrolamiento)">
              <i class="fas fa-eye iconDescarga"></i>
            </button>

            }
          </td>
          }

          @if (+tipoReporteSeleccionado === 0) {
          <!-- <td>{{item.sentidoDictaminacion}}</td> -->
          <td style="white-space: nowrap;">
            @if (+item.iStatusSolicitud === 2 || +item.iStatusSolicitud === 3) {
              <button class="icon-button" ngbTooltip="Ver motivo de la dictaminación"
                (click)="abrirModalMotivoDictaminacion(item.iStatusSolicitud,
                  item.sTextoAdicional, item.sMotivoRechazo 
                )">
                <i class="fas fa-sticky-note"></i>
              </button>
              {{item.sentidoDictaminacion}}
            }
          </td>  

          <td>@if (+item.iStatusSolicitud === 2){
             {{item.fechaDictamen}}
            } @else { 
              {{item.fechaRechazo}}
             }
          </td>
          <td>
            @if(item.usuarioRevisor.toString() === '1'){
            <button class="icon-button" ngbTooltip="Ver bitácora de cambios de estatus"
              (click)="abrirModalBitacoraEstatus(item.kIdAutoEnrolamiento)">
              <i class="fas fa-file-alt"></i>
            </button>
            }
          </td>
          <td>           
            <button class="icon-button" ngbTooltip="Reenviar correo" (click)="reenvioCorreo(item.kIdAutoEnrolamiento)">
              <i class="fas fa-envelope"></i>
            </button>         
          </td>
          <td>
            @if (item.iDocumentoAceptacion > 0) {
            <button class="icon-button" ngbTooltip="Visualizar"
              (click)="abrirModalDocumentoAceptacion(item.kIdAutoEnrolamiento)">
              <i class="fas fa-eye iconDescarga"></i>
            </button>
            }
          </td>
          }
          @if (+tipoReporteSeleccionado === 5) {
          <td>
            <button class="icon-button" ngbTooltip="Reenviar correo" (click)="reenvioCorreoValidacion(item.kIdAutoEnrolamiento,
              item.sAutoridad, item.sCorreoInstitucion
            )">
              <i class="fas fa-envelope"></i>
            </button>
          </td>
          }
          @if (+tipoReporteSeleccionado === 1) {
          <td>
            <button class="icon-button" ngbTooltip="Pasar registro a revisión"
              (click)="abrirModalRevision(item.kIdAutoEnrolamiento)">
              <i class="fas fa-check-circle"></i>
            </button>
          </td>
          <td>
            @if(item.usuarioRevisor.toString() === '1'){
            <button class="icon-button" ngbTooltip="Ver bitácora de cambios de estatus"
              (click)="abrirModalBitacoraEstatus(item.kIdAutoEnrolamiento)">
              <i class="fas fa-file-alt"></i>
            </button>
            }
          </td>
          }
        </tr>
        }
      </tbody>
    </table>

  </div>
  <ng-template #modalArchivos let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Documentos</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      @if(archivosModalLoading){
      <div>Cargando archivos...</div>
      }
      @if(!archivosModalLoading && archivosModalError){
      <div class="alert alert-danger">
        {{ archivosModalError }}
      </div>
      }

      @if(!archivosModalLoading && !archivosModalError){
      <div>
        <oaj-lista-archivos-itx [archivos]="archivosModal" [verBorrar]="false" [verPrevisualizar]="true"
          [verClasificacion]="false" [verArchivoEnvio]="true"></oaj-lista-archivos-itx>
        @if(!archivosModal.length){
        <div class="alert alert-info">
          No se encontraron archivos para este registro.
        </div>
        }

      </div>
      }
    </div>
  </ng-template>

  <ng-template #modalRevision let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Confirmar Revisión</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div>
        ¿Estás seguro de pasar este registro al estatus <strong>"En Revisión"</strong>?
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">No</button>
      <button type="button" class="btn btn-success" (click)="confirmarRevision()">Sí</button>
    </div>
  </ng-template>

  <ng-template #modalValPendiente let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Confirmar Regresar a Estatus Pendiente</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div>
        ¿Estás seguro de pasar este registro al estatus <strong>"Pendiente"</strong>?
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">No</button>
      <button type="button" class="btn btn-success" (click)="confirmarPendiente()">Sí</button>
    </div>
  </ng-template>

  <ng-template #modalBitacoraEstatus let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Bitácora de estatus</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="table-container tablaReimpresion">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Empleado</th>
              <th>Fecha Movimiento</th>
              <th>Estatus Solicitud</th>

            </tr>
          </thead>
          <tbody>
            @for (item of bitacoraEstatus; track $index) {
            <tr>
              <td>{{ $index + 1 }}</td>
              <td>{{ item.nombre }} {{ item.apellidoPaterno }} {{ item.apellidoMaterno }}</td>
              <td>{{ item.fechaMovimiento | date:'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ mapearEstatusModalBitacora(item.estatusSolicitud) }}</td>
            </tr>
            }

          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
    </div>
  </ng-template>

  <ng-template #modalMotivoDictaminacion let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Motivo de la dictaminación</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <p class="texto-motivo">{{ motivoDictaminacion }}</p>
    </div>
    <div class="modal-footer">
    </div>
  </ng-template>


</div>
}
@else {
<oaj-dictaminacion-positiva-component [idAutoEnrolamiento]="idMovimientoAutoEnrolamiento" [idUsuario]="idUsuaurio"
  (Regresar)="fnCerrarDictaminacion($event)"></oaj-dictaminacion-positiva-component>
}